import axios from 'axios';
import siteUrls from '../api-config/ApiConfig';

async function getOrResponse(url, config) {
  try {
    return await axios.get(url, config);
  } catch (error) {
    if (error?.response) return error.response;
    throw error;
  }
}

async function postOrResponse(url, payload) {
  try {
    return await axios.post(url, payload);
  } catch (error) {
    if (error?.response) return error.response;
    throw error;
  }
}

export async function listPublicChits(params = {}) {
  return getOrResponse(siteUrls.guest.chits, { params });
}

export async function getPublicChit(id) {
  return getOrResponse(`${siteUrls.guest.chits}/${id}`);
}

export async function getJoinAmount(chitId) {
  return getOrResponse(siteUrls.guest.joinChitAmount, {
    params: { chit_id: chitId },
  });
}

export async function setGuestInterest(chitId, status) {
  return postOrResponse(siteUrls.guest.guestInterest, {
    chit: chitId,
    status,
  });
}

export async function getGuestInterest(chitId) {
  return getOrResponse(siteUrls.guest.guestInterestByChit(chitId));
}

export async function startJoinChit(chitId, paymentGateway = 'razorpay') {
  return postOrResponse(siteUrls.guest.joinChit(chitId), {
    website: true,
    paymentGateway,
  });
}

/** Re-issue access/refresh tokens for the current user (role may have changed). */
export async function refreshAuthSession() {
  const token = localStorage.getItem('access-token');
  try {
    return await axios.post(
      siteUrls.guest.refreshToken,
      {
        device_id: 'landing-guest-web',
        ip: 'landing-page',
      },
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );
  } catch (error) {
    if (error?.response) return error.response;
    throw error;
  }
}
